var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3895_31097)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.234 18.4758L14.3258 23.6446C13.5698 24.0828 12.5996 23.5522 12.5996 22.6688V12.3312C12.5996 11.4492 13.5684 10.9172 14.3258 11.3568L23.234 16.5256C23.406 16.6238 23.5489 16.7657 23.6484 16.9369C23.7478 17.1082 23.8002 17.3027 23.8002 17.5007C23.8002 17.6987 23.7478 17.8932 23.6484 18.0645C23.5489 18.2357 23.406 18.3776 23.234 18.4758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3895_31097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPlay);
export default __webpack_public_path__ + "static/media/player-play.ef0704ec.svg";
export { ForwardRef as ReactComponent };